import Swiper from 'swiper/dist/js/swiper' // use umd (support for IE11) TODO: tree shaking
import projectBase from '../projectBase'

/**
 * @doc https://idangero.us/swiper/api/
 * @doc https://idangero.us/swiper/demos/
 */
export default class Carousel {
  constructor(selector) {
    this.el = document.querySelectorAll(selector)

    this.options = {
      loop: true,
      preloadImages: true,
      updateOnImagesReady: true,
      autoplayDisableOnInteraction: false,
      on: {
        imagesReady: this.swiperImagesReady.bind(this),
      },
    }

    if (this.el.length) {
      this.initialize()
    }
  }

  initialize() {
    // // 状態
    // this.state = {
    //   $window: {
    //     width: projectBase.state.width,
    //   },
    //   isMobile: projectBase.state.isMobile,
    // }

    this.instances = [...this.el].map((el) => {
      const $carousel = {}
      const target = el.querySelector('.swiper-container')
      const navEl = [...el.querySelectorAll('[data-nav]')]
      let options = { ...this.options }

      if (el.dataset.options) {
        try {
          options = Object.assign(
            { ...options },
            JSON.parse(el.dataset.options)
          )
        } catch (err) {
          console.warn(
            '[carousel::initialize] Setup failed. json syntax is broken.'
          )
        }
      }

      const swiper = this.setup(target, options)

      if (navEl.length) {
        navEl.forEach((nEl) => {
          const type = nEl.dataset.nav
          switch (type) {
            case 'prev':
              nEl.addEventListener('click', () => {
                swiper.slidePrev()
              })
              break
            case 'next':
              nEl.addEventListener('click', () => {
                swiper.slideNext()
              })
              break
          }
        })
      }

      $carousel.$el = target
      $carousel.swiper = swiper

      el.classList.add('is-swiper-ready')
      return $carousel
    })

    // this.bind()
  }

  setup(target, options) {
    const swiper = new Swiper(target, options)
    return swiper
  }

  swiperImagesReady() {
    if (this.el) {
      this.el[0].classList.add('swiper-images-ready')
    }
  }

  // bind() {
  //   this.onResize = this.onResize.bind(this)
  //   PubSub.subscribe('App.resize', this.onResize)
  // }

  // onResize({ width, isMobile }) {
  //   this.state.$window.width = width
  //   this.state.isMobile = isMobile
  // }
}
